<!--
    描述：岗位信息
    日期：2021/04/28
    作者：zwh
-->
<template>
    <div class="h100">
        <div class="w-page-main">
            <div class="w-page-header superiors-search-area">
                <div class="left-text overflow-hidden">
                    <span><b>岗位列表</b></span>
                </div>
                <div class="btnGroups">
                    <el-button type="primary" size="small" icon="el-icon-check"
                        v-if="roleBtns.includes('post_add')" @click="doClick('','add')">新增
                    </el-button>
                </div>
            </div>

            <div class="w-page-container pdb10">
                <div class="w-table-layout">
                    <div class="w-table-content" ref="content">
                        <el-table :data="treeObj.data"
                                  row-key="id"
                                  v-loading="treeObj.loading"
                                  ref="tree"
                                  default-expand-all
                                  :height="treeObj.tableH"
                                  border
                                  highlight-current-row
                                  @row-click="rowClick"
                                  :tree-props="{children: 'children'}">
                            <el-table-column prop="sname"
                                             label="岗位名称"
                                             header-align="center"
                                             show-overflow-tooltip
                                             min-width="130"></el-table-column>
                            <el-table-column label="操作"
                                             align="center"
                                             show-overflow-tooltip
                                             width="105">
                                <template slot-scope="scope">
                                    <el-button size="mini"
                                               icon="el-icon-plus"
                                               title="新增"
                                               v-if="roleBtns.includes('post_add') && !scope.row.readOnly"
                                               type="text"
                                               @click="doClick(scope.row,'add')"></el-button>
                                    <el-button size="mini"
                                               icon="el-icon-edit"
                                               title="编辑"
                                               v-if="roleBtns.includes('post_edit') && !scope.row.readOnly"
                                               type="text"
                                               @click="doClick(scope.row,'edit')"></el-button>
                                    <el-button v-if="roleBtns.includes('post_delete') && !scope.row.readOnly "
                                               size="mini"
                                               icon="el-icon-delete"
                                               title="删除"
                                               type="text"
                                               @click="doClick(scope.row,'delete')"></el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>

        <!-- 新增、编辑等弹窗 -->
        <el-dialog :title="dialogObj.title"
                   :visible.sync="dialogObj.visible"
                   :width="dialogObj.width"
                   :close-on-click-modal="false"
                   @closed="handleClose">
            <!-- 弹窗组件 -->
            <postAdd ref="postAdd"
                     v-if="dialogObj.visible"
                     :mode="dialogObj.mode"
                     :transObj="transObj"
                     @handle-success="handleSuccess"></postAdd>
            <!-- footer 组件 -->
            <div slot="footer"
                 class="dialog-footer text-center"
                 v-if="dialogObj.mode !== 'view'">
                <el-button size="small"
                           @click="dialogObj.visible = false">取 消</el-button>
                <el-button type="primary"
                           size="small"
                           :loading="btnLoading"
                           @click="doSave">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import postAdd from './post_add_dialog'
import { selectAll,deleteById } from 'api/system/sysPosition.js'
export default {
    name : '',
    components: {
        postAdd,
    },
    data() {
        return {
            btnLoading : false,
            //子组件传递对象
            transObj: {
                id: '',
                groupId : '',
                groupName : '',
                parentId: '',
                parentName: '',
                type: ''
            },

            treeObj: {
                loading: false,
                tableH: 200,
                data: []
            },
            //弹框对象
            dialogObj: {
                title: '',
                visible: false,
                width: '650px',
                mode: 'add'
            },
        }
    },
    mounted() {
        this.$nextTick(() => {
            setTimeout(() => {
                this.treeObj.tableH = this.$refs.content.offsetHeight
            }, 100)
        })
    },
    computed: {
        ...mapState('app', {clientSize: state => state.clientSize}),
        ...mapState('menu', {
            roleBtns: state => state.roleBtns
        })
    },
    watch: {
        clientSize(val) {
            this.treeObj.tableH = this.$refs.content.offsetHeight
        }
    },
    created() {
        this.getPostList()
    },
    methods: {
        getPostList(){
            let that = this
            let param = { }
            selectAll(param).then(res=>{
                if(res.operationCode == 1) {
                    that.treeObj.data = res.data
                }
            })
        },
        doClick(obj, type){
            let that = this
            that.dialogObj.mode = type
            if (type === 'add') {   //新增
                this.transObj.id = ''
                if (obj != '') {    //新增子节点
                    this.transObj.parentId = obj.id
                    this.transObj.parentName = obj.roleName
                } else {    //新增父岗位
                    this.transObj.parentId = '0'
                    this.transObj.parentName = ''
                }
                this.dialogObj.title = '新增岗位'
                this.dialogObj.visible = true
            } else if (type === 'edit') {   //编辑
                this.transObj.id = obj.id
                this.transObj.parentId = ''
                this.transObj.parentName = ''
                this.dialogObj.title = '编辑岗位'
                this.dialogObj.visible = true
            } else if (type === 'delete') { //删除
                this.delete(obj)
            }
        },
        //删除
        delete(obj) {
            let that = this
            this.$confirm(
                '删除角色信息，将会删除角色菜单、角色菜单按钮、权限数据等信息，确认删除吗?',
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).then(() => {
                let param = {
                    id: obj.id,
                }
                deleteById(param).then(res => {
                    if (res.operationCode == 1) {
                        if(res.msg == 'faild') {
                            that.$message({ message: res.data, type: 'error' })
                            return
                        }
                        that.$message({ message: '删除成功', type: 'success' })
                        this.getPostList()
                        this.$emit('row-click', '')
                    } else {
                        that.$message({ message: res.msg, type: 'error' })
                    }
                })
            })
        },
        //行点击
        rowClick(obj) {
            this.$emit('row-click', obj)
        },
        // 确定按钮事件
        doSave() {
            this.$refs.postAdd.doSave()
        },
        //新增/编辑菜单成功
        handleSuccess() {
            this.dialogObj.visible = false
            this.getPostList()
        },
        // 关闭弹窗事件
        handleClose() {},
    }
}
</script>
<style lang="less">

</style>